import { InputNumber, InputNumberProps } from 'antd';
import { getLocale } from 'translations/locale';
import { Locale } from 'translations/types';

import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';

const parseDecimalInput = (
  input: string | undefined,
  decimalLimit?: number,
) => {
  if (!input || input.length === 0) {
    return '';
  }

  const standardizedInput = input.replace(/[\.,]/, '.');

  if (decimalLimit === undefined) {
    return standardizedInput;
  }

  const decomposedInput = standardizedInput.split('.');

  if (decimalLimit === 0 || decomposedInput.length < 2) {
    return decomposedInput[0];
  }

  decomposedInput[1] = decomposedInput[1].substring(0, decimalLimit);
  return `${decomposedInput[0]}.${decomposedInput?.[1]}`;
};

const formatDecimalInput = (
  input: string | number | undefined,
  decimalLimit?: number,
) => {
  if (!input) {
    return '';
  }

  const locale = getLocale();
  const numberValue = parseFloat(input.toString());

  if ([Locale.fr, Locale.es].includes(locale)) {
    if (!isUndefinedOrNull(decimalLimit)) {
      return numberValue.toFixed(decimalLimit).replace(/[\.,]/, ',');
    }
    return numberValue.toString().replace(/[\.,]/, ',');
  }

  if (!isUndefinedOrNull(decimalLimit)) {
    return numberValue.toFixed(decimalLimit).replace(/[\.,]/, '.');
  }
  return numberValue.toString().replace(/[\.,]/, '.');
};

export const DecimalInput = ({
  decimalLimit,
  ...rest
}: Omit<
  React.PropsWithChildren<InputNumberProps<string | number>> &
    React.RefAttributes<HTMLInputElement>,
  'parser' | 'formatter'
> & { decimalLimit?: number }) => {
  return (
    <InputNumber
      {...rest}
      parser={(input) => parseDecimalInput(input, decimalLimit)}
      formatter={(input) => formatDecimalInput(input, decimalLimit)}
    />
  );
};
